import React from "react";
import PropTypes from "prop-types";
import i18next from "i18next";

/**
 * a simple text like button
 * @returns JSX component
 */
const SimpleButton = ({
    onClick,
    customStyle = "",
    label,
    icon,
    iconPosition = "left",
    asText = false,
    disabled = false,
}) => {
    const asTextStyles = `${asText ? "simple-btn--text" : ""}`;
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`simple-btn ${asTextStyles} ${customStyle}`}
        >
            {icon && iconPosition === "left" && icon}
            {React.isValidElement(label) ? label : i18next.t(label)}
            {icon && iconPosition === "right" && icon}
        </button>
    );
};

SimpleButton.propTypes = {
    onClick: PropTypes.func,
    customStyle: PropTypes.string,
    icon: PropTypes.node,
    iconPosition: PropTypes.oneOf(["left", "right"]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    asText: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default SimpleButton;
